import { useContext } from 'react';
import { styles } from './FAQ.style';
import { Dialog, DialogContent, IconButton, Typography, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationContext } from '@context/LocalizationContext';
import { errorHandler } from '@/Config/ErrorHandler';

interface FAQModalProps {
	isOpen: boolean;
	setIsOpen: Function;
}

export default function FAQModal(props: FAQModalProps) {
	const { FAQ } = useContext(LocalizationContext);

	const faq = () => {
		let data: any;
		try {
			data = JSON.parse(FAQ.data);
		} catch (err: any) {
			errorHandler(new Error('Cannot parse FAQ data'), err);
			return <></>;
		}
		if (data) {
			return (
				<Stack gap={'16px'} data-cy={'pqFaqDialog'}>
					<Typography sx={styles.faqTitle}>{FAQ.Title}</Typography>
					{data.map((qna: { Question: string; Answer: string }) => (
						<Stack gap={'2px'} key={qna.Question}>
							<Typography sx={styles.question} key={qna.Question}>
								{qna.Question}
							</Typography>
							<Typography sx={styles.answer} key={qna.Answer}>
								{qna.Answer}
							</Typography>
						</Stack>
					))}
				</Stack>
			);
		}
	};

	return (
		<>
			{/* Desktop */}
			<Dialog
				open={props.isOpen}
				PaperProps={styles.container}
				onClose={() => props.setIsOpen(false)}
				scroll={'body'}
				sx={{ display: { xxs: 'none', xs: 'none', sm: 'none', md: 'inline' } }}>
				<IconButton
					data-cy={'pqFaqCloseButton'}
					aria-label="close"
					onClick={() => props.setIsOpen(false)}
					sx={styles.xButton}
					children={<CloseIcon />}
				/>
				<DialogContent sx={styles.content}>{faq()}</DialogContent>
			</Dialog>

			{/* Mobile */}
			<Dialog
				open={props.isOpen}
				PaperProps={styles.mobileContainer}
				onClose={() => props.setIsOpen(false)}
				scroll={'body'}
				sx={{ display: { xs: 'flex', md: 'none' } }}>
				<IconButton
					aria-label="close"
					onClick={() => props.setIsOpen(false)}
					sx={styles.xButton}
					children={<CloseIcon />}
				/>
				<DialogContent sx={styles.content}>{faq()}</DialogContent>
			</Dialog>
		</>
	);
}
